import { IPaginationRequest } from "model/Common";

export interface IQualityCondition {
  id: string;
  groupID: string;
  name: string;
  displayOrder: number;
  warehouseId: string | null;
  type: EQualityCheckingConditionType;
  imageRequired: boolean | number;
  nameEN?: string;
}

export interface IGetAllQualityCondition extends IPaginationRequest {
  groupId?: string;
}

export enum EQualityCheckingConditionType {
  Predefined,
  InputText,
}
